import './_product-text-options.scss';

export default () => {};
